export const userSetIsOnboarding = (isOnboarding) => ({
  type: 'USER_SET_IS_ONBOARDING',
  isOnboarding,
});

export const userUpdateCurrentUser = (currentUser) => ({
  type: 'USER_UPDATE_CURRENT_USER',
  currentUser,
});
